
# China & the Art of the Freight

Pre-covid, from approximately 2010-2020, there was the art of the deal written in the form of an RFM.

What's an RFM, you ask? Let's head to [Alibaba](https://alibaba.com)...

## Alibaba: Request for Manufacturer/Quotation

- [RFP & RFQ Trading Platform | Alibaba.com’s Global Sourcing Marketplace](https://rfq.alibaba.com/)

What does this mean exactly? More or less everything you find on Amazon has a Chinese manufacturing counterpart that is rebranded.

TaoTronics, Tribe, etc...

The manufacturing process happens without a patent and the manufacturer can then sell to the highest bidder. The name of the game is to either have high volume or high margins.

## [FIXD](https://get.fixdapp.com/home/1-0)

I was more or less employee 5 at a company called FIXD. It budded out of a college project in order to plug in a computer to a car through an OBD2 port found on all cars after 1996. This is pretty genius because it cuts out the middle man mechanic on all check engine lights.

## Arm Band

Meanwhile in 2018/2020 I've now purchased two separate running armbands after my 2018 band died due to sweat and more.

- [Amazon.com: Revere Sport iPhone X/XS Running Armband (Face Recognition). Sports Phone Case Holder for Runners: Electronics](https://www.amazon.com/gp/product/B075SL4QYT/ref=ppx_yo_dt_b_search_asin_title?ie=UTF8&psc=1)

This first purchase was great. Neoprene with a nice easy instruction kit for A->B about how to put it on.

- [Amazon.com: TRIBE Water Resistant Cell Phone Armband Case for iPhone 11, 11 Pro, 11 Pro Max, X, Xs, Xs Max, Xr, 8, 7, 6, Plus Sizes, Galaxy S10, S9, S8, S7, Plus Sizes and More. Adjustable Elastic Band & Key Slot](https://www.amazon.com/gp/product/B07JL74R2J/ref=ppx_yo_dt_b_search_asin_title?ie=UTF8&psc=1)

Next, in 2020 I've purchased a new one with a different "brand" that is nearly identical.

## Conclusion

Chinese/American capitalism at its finest.

